import React, { useState, useEffect, Fragment } from "react";

import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { helperFunction } from "../../constant/helper";
import { locationActions } from "../../redux/actions";
import Button from "../../component/button/Button";
import Card from "../../component/card/Card";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import P from "../../component/smallComponents/P";
import SelectInput from "../../component/input/SelectInput";
import Strong from "../../component/smallComponents/Strong";
import TextInput from "../../component/input/TextInput";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import Starter from "../../component/Starter";

const LocationTypes = {
  HEAD_OFFICE: "HEAD OFFICE",
  PLANT: "PLANT",
  OFFICE: "OFFICE"
};

const initialState = {
  state: "",
  latitude: "",
  longitude: "",
  selectType: "",
  locationName: "",
  locationCity: "",
  locationCode: ""
};

const loginType = localStorage.loginType;

const RegisterLocation = () => {
  const dispatch = useDispatch();
  const [values, setValues] = useState(initialState);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  const {
    locationError,
    locationLoading,
    locationResponse
  } = useSelector((state) => state.location);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
  }, [locationError]);

  useEffect(() => {
    if (locationResponse) {
      helperFunction.toastHelper("success", locationResponse);
    }
  }, [locationResponse]);

  const showLocationType = Object.values(LocationTypes).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  const onLocationRegister = (e) => {
    e.preventDefault();
    const locationInfo = {
      latitude: values.latitude.trim().toUpperCase(),
      locationState: values.state.trim(),
      longitude: values.longitude.trim().toUpperCase(),
      locationType: values.selectType.trim().toUpperCase(),
      locationName: values.locationName.trim().toUpperCase(),
      locationCity: values.locationCity.trim().toUpperCase(),
      locationCode:
        values.locationName.charAt(0).toUpperCase() +
        values.selectType.charAt(0).toUpperCase() +
        values.locationCity.charAt(0).toUpperCase()
    };
    dispatch(locationActions.setLocationLoading(true));
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(locationActions.createLocation(locationInfo, loginType));
  };

  useEffect(() => {
    dispatch(locationActions.setLocationLoading(false));
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    return () => {
      dispatch(locationActions.setLocationLoading(false));
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
    };
  }, []);

  return (
    <Starter
      topBarTitle="Register Locations"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Register Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Location</a>
          </li>
          <li className="breadcrumb-item active">
            Register Locations
          </li>
        </Fragment>
      }
    >
      <Card>
        <div className="row mb-2">
          <div className="col-sm-4">
            <Link
              to="/hr/location/all-locations"
              className="btn mb-2 text-white btn-dark"
            >
              <i className="mdi mdi-plus-circle mr-2"></i> All
              Locations
            </Link>
          </div>
          <div className="col-sm-8">
            <div className="text-sm-right"></div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              title="Add Locations"
              isClassName={false}
            />
            <P title="Fill the form below to Add Locations data" />
          </div>
        </div>

        <form className="pl-3 pr-3" onSubmit={onLocationRegister}>
          <div className="row">
            <div className="col-md-4 mb-4">
              <SelectInput
                required={true}
                isLabeled={true}
                textWhite={false}
                name="selectType"
                label="Select Type"
                value={values.selectType}
                onChange={handleInputChange}
              >
                {showLocationType}
              </SelectInput>
            </div>
            <div className="col-md-4 mb-4">
              <TextInput
                type="text"
                required={true}
                textWhite={false}
                name="locationName"
                htmlFor="locationName"
                value={values.locationName}
                onChange={handleInputChange}
                label={`Enter Name ${values.selectType}`}
                placeholder={`Enter Name ${values.selectType}`}
              />
            </div>
            <div className="col-md-4 mb-4">
              <TextInput
                type="text"
                required={true}
                textWhite={false}
                name="locationCity"
                htmlFor="locationCity"
                value={values.locationCity}
                onChange={handleInputChange}
                label={`Enter City ${values.selectType}`}
                placeholder={`Enter City ${values.selectType}`}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-4">
              <SelectInput
                name="state"
                required={true}
                htmlFor="state"
                isLabeled={true}
                textWhite={false}
                value={values.state}
                label={`Enter ${values.selectType} State`}
                placeholder={`Enter ${values.selectType} State`}
                onChange={handleInputChange}
              >
                {helperFunction.renderState()}
              </SelectInput>
            </div>
            <div className="col-md-4 mb-4">
              <TextInput
                type="text"
                required={true}
                name="latitude"
                textWhite={false}
                htmlFor="latitude"
                value={values.latitude}
                onChange={handleInputChange}
                label={`Enter ${values.selectType} latitude`}
                placeholder={`Enter ${values.selectType} latitude`}
              />
            </div>
            <div className="col-md-4 mb-4">
              <TextInput
                type="text"
                required={true}
                name="longitude"
                textWhite={false}
                htmlFor="longitude"
                value={values.longitude}
                onChange={handleInputChange}
                label={`Enter ${values.selectType} longitude`}
                placeholder={`Enter ${values.selectType} longitude`}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3"></div>
            <div className="col-md-2 mb-2"></div>
            <div className="col-md-2 mb-2">
              {locationLoading ? (
                <SpinnerButton />
              ) : (
                <Button
                  type="submit"
                  title="Add Locations"
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                  className="btn mb-2 text-white btn-dark"
                />
              )}
            </div>
            <div className="col-md-3 mb-3"></div>
            <div className="col-md-2 mb-2"></div>
          </div>
        </form>
      </Card>
    </Starter>
  );
};

export default RegisterLocation;
